// PROD
export const HOST_URL = "https://www.iciciprualternates.com";
export const SITE_ID = "?crafterSite=pms-production";
// UAT
// export const HOST_URL = "https://api.uat.icicipruai.com";
// export const SITE_ID = "?crafterSite=pms-uat";

export const BASE_URL = HOST_URL + "/api/v1";
export const IMAGE_URL = HOST_URL;
export const GET_METHOD = "GET";
export const POST_METHOD = "POST";

// PROD
export const LMS_FORM_BASE_URL =
  "https://www.iciciprualternates.com/lms/form/api/v1";
export const OTP_BASE_URL = "https://www.iciciprualternates.com/lms/otp/api/v1";

// UAT
// export const LMS_FORM_BASE_URL =
//   "https://uat-investorportal.icicipruamc.com/lms/form/api/v1";
// export const OTP_BASE_URL =
//   "https://uat-investorportal.icicipruamc.com/lms/otp/api/v1";

function getUrl(path) {
  return BASE_URL + path + SITE_ID;
}

export const HOME_URL = getUrl("/home.json");
export const AIF_URL = getUrl("/aif.json");
export const OFFERING_URL = getUrl("/ourofferings.json");
export const Privacy_URL = getUrl("/privacypolicy.json");
export const Statutary_URL = getUrl("/statutorydetails.json");
export const Legal_URL = getUrl("/legalterm.json");
export const Investor_URL = getUrl("/investorcorner.json");
export const FAQ_URL = getUrl("/faq.json");
export const ABOUT_URL = getUrl("/about.json");
export const NEWSROOM_URL = getUrl("/newsroom.json");
export const CONTACT_URL = getUrl("/contactus.json");
export const ACCOUNT_URL = getUrl("/openaccount.json");
export const INVEST_WITH_US_URL = getUrl("/investwithus.json");
export const LEARN_MORE_CONTRA = getUrl("/contraLearnMore.json");
export const LEARN_MORE_ACE = getUrl("/aceLearnMore.json");
export const LEARN_MORE_FLEXICAP = getUrl("/flexicapLearnMore.json");
export const LEARN_MORE_PIPE = getUrl("/pipeLearnMore.json");
export const LEARN_MORE_LARGE_CAP = getUrl("/largecap.json");
export const LEARN_MORE_VALUE = getUrl("/valueLearnMore.json");
export const SebiDoc_URL = getUrl("/sebi.json");

export const LOGIN_URL =
  "https://www.iciciprualternates.com/lms/report/api/v1" + "/user/login";
export const CONTRA_STRATEGY_URL = BASE_URL + "/contra.json" + SITE_ID;
export const FLEXICAP_STRATEGY_URL = BASE_URL + "/flexicap.json" + SITE_ID;
export const VALUE_STRATEGY_URL = BASE_URL + "/value.json" + SITE_ID;
export const LARGECAP_STRATEGY_URL = BASE_URL + "/largecap.json" + SITE_ID;
export const PIPE_STRATEGY_URL = BASE_URL + "/pipe.json" + SITE_ID;
export const ACE_STRATEGY_URL = BASE_URL + "/ace.json" + SITE_ID;
export const SEND_OTP_URL = OTP_BASE_URL + "/generateOtp";
export const VALIDATE_OTP_URL = OTP_BASE_URL + "/validateOtp";
export const EMAIL_CONFIG_URL = OTP_BASE_URL + "/getSmtpDetails";
export const INVESTOR_CHARTER_URL = getUrl("/navigation.json");

export const CONTACT_US_FORM = LMS_FORM_BASE_URL + "/setContactUsDetails";
export const INVEST_WITH_US_FORM =
  LMS_FORM_BASE_URL + "/setInvestWithUsDetails";
export const CREATE_ACCOUNT_FORM =
  LMS_FORM_BASE_URL + "/setCreateAccountDetails";
export const ENQUIRY_FORM = LMS_FORM_BASE_URL + "/setEnquiryDetails";
export const SUBSCRIBE_VIA_EMAIL_URL = LMS_FORM_BASE_URL + "/subscribeViaEmail";
export const UN_SUBSCRIBE_VIA_EMAIL_URL = LMS_FORM_BASE_URL + "/unsubscribe";
export const PRE_LOGIN_EMAIL =
  "https://www.iciciprualternates.com/userapi/common/preloginEmail";
